// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n[data-v-298cf10c] .form-create .form-create .el-form-item .el-form-item {\n  margin-bottom: 18px !important;\n}\n", ""]);
// Exports
module.exports = exports;
